import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, CircleCheckBig, Clock } from 'lucide-react';
import { courses } from '../content';
import { useProgress } from '../hooks/useProgress';
import Icon from '../components/Icon';

export default function Courses() {
  const { courseDone, quizScore, reset, doneCount } = useProgress();
  return (
    <div className="page">
      <div className="section-head left">
        <p className="eyebrow">All courses</p>
        <h1 className="page-title">Pick a step</h1>
        <p>Seven courses that build on each other. Your progress is saved in this browser.</p>
      </div>
      <div className="course-grid">
        {courses.map((c, i) => {
          const done = courseDone(c);
          const mins = c.lessons.reduce((s, l) => s + l.minutes, 0);
          const q = quizScore(c.id);
          return (
            <motion.div
              key={c.id}
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.06 }}
              whileHover={{ y: -6 }}
              style={{ '--c1': c.colors[0], '--c2': c.colors[1] }}
            >
              <Link to={`/course/${c.id}`} className="course-card">
                <div className="course-card-top">
                  <span className="course-card-step">{c.step}</span>
                  <Icon name={c.icon} size={34} />
                </div>
                <div className="course-card-body">
                  <span className="pill">{c.level}</span>
                  <h2>{c.title}</h2>
                  <p>{c.tagline}</p>
                  <div className="course-card-meta">
                    <span><Clock size={15} /> {mins} min</span>
                    <span><CircleCheckBig size={15} /> {done}/{c.lessons.length} lessons</span>
                    {q !== undefined && <span>Quiz {q}/{c.quiz.length}</span>}
                  </div>
                  <div className="bar"><span style={{ width: `${(done / c.lessons.length) * 100}%` }} /></div>
                  <span className="course-card-go">Open course <ArrowRight size={16} /></span>
                </div>
              </Link>
            </motion.div>
          );
        })}
      </div>
      {doneCount > 0 && (
        <p className="reset-row">
          <button type="button" className="link-btn" onClick={reset}>Reset my progress</button>
        </p>
      )}
    </div>
  );
}
